import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
  LinkButton,
  Badge,
} from "../components/ui";
import { useSeo } from "../lib/seo";

export function Customers() {
  useSeo({
    title: "Customers — WeConsult Rx",
    description:
      "Case studies, customer stories, and outcomes from consultant pharmacists using WeConsult Rx.",
    path: "/customers",
  });

  return (
    <Section>
      <Container>
        <div className="max-w-3xl">
          <Eyebrow>Customers</Eyebrow>
          <Heading level={1} className="mt-3">
            Stories coming soon.
          </Heading>
          <Lede className="mt-6">
            We’re onboarding early consultant pharmacy practices now. Case
            studies and outcome data will land here as customers go live.
          </Lede>
          <div className="mt-8 flex gap-3">
            <LinkButton to="/demo">Become a launch customer</LinkButton>
          </div>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {["Long-term care practice · TBD", "Ambulatory surgical practice · TBD", "Dialysis-focused practice · TBD"].map((c) => (
            <Card key={c}>
              <Badge tone="neutral">Case study placeholder</Badge>
              <p className="mt-4 text-ink-700">{c}</p>
            </Card>
          ))}
        </div>
      </Container>
    </Section>
  );
}
